import React from "react";
import "./style.less";
import { get, post } from "../../utils/axHttp";
import JmAlert from "../../components/JmAlert/index.jsx";
// import OrderDetail from "./OrderDetail.jsx";
import CountDown from "./countDown.jsx";
import { CopyToClipboard } from "react-copy-to-clipboard";
import btn from "./image/sbtn.png";

export default class Wait extends React.Component {
  constructor(props) {
    document.title = "开服预约";
    super(props);
    this.state = {
      mobile: "",
      vcode: "",
      vCodeText: "获取验证码",
      isSendSms: true,
      moreCss: {},
    };
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    get("/activity/webAppointmentInfo", {}).then((res) => {
      console.log(res);
      if (res.code === 0) {
        let moreCss = {};
        res.data.left && (moreCss.paddingLeft = res.data.left + "rem");
        res.data.color && (moreCss.color = res.data.color);
        this.setState({
          backgroundImageBg: `url(${res.data.background_img})`,
          backgroundImageAlert: `url(${res.data.alert_img})`,
          backgroundImageBtn: res.data.button_img,
          rule: res.data.rule,
          mobile: res.data.mobile,
          isBindMobile: res.data.is_bind_mobile,
          isLog: res.data.is_log,
          moreCss: moreCss,
        });
      } else if (res.code === 44309) {
        this.props.history.push({
          pathname: "/login",
          query: { backUrl: "/activity/lottery", url: window.location.href },
        });
      } else {
        JmAlert.open({
          title: "提示",
          alertTip: res.message,
        });
      }
    });
  }

  getVcode() {
    if (!this.state.isSendSms) {
      return;
    } else {
      this.setState({ isSendSms: false });
    }
    get("/webconfig/sendSms", {
      phone: this.state.mobile,
      check: 1,
    }).then((res) => {
      console.log(res);
      if (res.code === 0) {
        this.vCodeBtn();
        JmAlert.open({
          title: "恭喜",
          alertTip: res.message,
        });
      } else {
        JmAlert.open({
          title: "提示",
          alertTip: res.message,
        });
      }
    });
  }

  vCodeBtn() {
    let num = 60;
    let timer = setInterval(() => {
      if (num <= 0) {
        this.setState({ vCodeText: "获取验证码", isSendSms: true });
        window.clearInterval(timer);
        return;
      }
      this.setState({ vCodeText: num });
      num--;
    }, 1000);
  }

  /**
   * 绑定并且预约
   */
  bindPhone() {
    if (this.state.isBindMobile) {
      this.order();
      return;
    }
    post("/webconfig/bindPhone", {}).then((res) => {
      if (res.code === 0) {
        this.setState({ isBindMobile: 1 });
        this.order();
      } else {
        JmAlert.open({
          title: "提示",
          alertTip: res.message,
        });
      }
    });
  }

  order() {
    if (!/^1[3-9]\d{9}$/.test(this.state.mobile)) {
      JmAlert.open({
        title: "提示",
        alertTip: "手机号码输入有误",
      });
      return;
    }

    post("/Activity/appointmentLog", { phone: this.state.mobile }).then(
      (res) => {
        if (res.code === 0) {
          this.setState({ isLog: 1 });
          JmAlert.open({
            title: "恭喜",
            alertTip: res.message,
          });
        } else {
          JmAlert.open({
            title: "提示",
            alertTip: res.message,
          });
        }
      }
    );
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  }

  render() {
    let btnText;
    if (this.state.isLog) {
      btnText = (
        <div style={{ marginTop: 10, fontSize: 14, fontWeight: 700 }}>
          <div>邀请超过5位一起来PK还能有更多福利您的分享链接</div>
          <CopyToClipboard
            onCopy={(e) =>
              JmAlert.open({
                title: "提示",
                alertTip: "复制成功",
              })
            }
            text="https://itunes.apple.com/cn/app/id1552532839"
          >
            <div className="url">
              https://itunes.apple.com/cn/app/id1552532839
            </div>
          </CopyToClipboard>
        </div>
      );
    } else {
      btnText = (
        <div className="btn">
          <img onClick={this.order.bind(this)} src={btn} alt="" />
          {/* <img
            onClick={this.bindPhone.bind(this)}
            src={btn}
            alt=""
          /> */}
        </div>
      );
    }
    let phoneContent;
    if (this.state.mobile) {
      phoneContent = (
        <div>
          手机号：{this.state.mobile}，<span>已预约</span>
        </div>
      );
    } else {
      phoneContent = <span>已预约</span>;
    }

    return (
      <div className="wait_box_index2">
        <h2>开服倒计时</h2>
        <CountDown endTime="2021-03-06 13:00" />
        <div
          className="rule"

          // dangerouslySetInnerHTML={{ __html: this.state.rule }}
        >
          <p>
            万众期待，勇士征集令已经已经开始传递。即将在3月6号13点准时开服，现在预约还将在开服时获得神秘奖励，一起来PK吧！
          </p>
          <div
            style={{
              display: this.state.isLog ? "block" : "none",
            }}
            className="phone"
          >
            {phoneContent}
          </div>
        </div>
        <div className="scanner">
          <div
            style={{
              display: this.state.isLog ? "none" : "flex",
            }}
          >
            <div>手机号码</div>
            <input
              type="text"
              placeholder="请输入手机号码"
              value={this.state.mobile}
              onChange={this.handleInputChange}
              readOnly={this.state.isBindMobile}
              name="mobile"
            />
          </div>
          {/* <div
            style={{
              display: this.state.isBindMobile ? "none" : "flex",
            }}
          >
            <div>验证码</div>
            <input
              type="text"
              placeholder="请输入验证码"
              value={this.state.vcode}
              onChange={this.handleInputChange}
              name="vcode"
            />
            <div className="get_v_code" onClick={this.getVcode.bind(this)}>
              {this.state.vCodeText}
            </div>
          </div> */}
        </div>
        {btnText}
      </div>
    );
  }
}
